import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import VueCookie from 'vue-cookie'
Vue.use(Vuex)
Vue.use(VueCookie)

export default new Vuex.Store({
  state: {
    token: Vue.cookie.get('user-token') || '',
    name: Vue.cookie.get('user-name') || '',
    hostname: '',
    status: '',
    hasLoadedOnce: false,
    profile: {}
  },
  getters: {
    hostname: state => state.hostname,
    isAuthenticated: state => !!state.token,
    ifPayments: state => state.token.length > 32,
    isName: state => state.name,
    authStatus: state => state.status,
    getProfile: state => state.profile,
    isProfileLoaded: state => !!state.profile.name
  },
  actions: {
    AUTH_REQUEST: ({ commit, dispatch, getters }, user) => {
      return new Promise((resolve, reject) => {
        commit('AUTH_REQUEST')
        axios({ url: 'backend/auth', data: user, method: 'POST' })
          .then(res => {
            var resp = res.data
            if (resp.token) {
              Vue.cookie.set('user-token', resp.token, {expires: '1Y', domain: getters.hostname})
              axios.defaults.headers.common['Token'] = resp.token
              commit('AUTH_SUCCESS', resp)
              dispatch('USER_REQUEST')
              resolve(resp)
            }
          })
          .catch(err => {
            commit('AUTH_ERROR', err)
            Vue.cookie.delete('user-token')
            reject(err)
          })
        axios({ url: 'api/auth', data: user, method: 'POST' })
          .then(res => {
            var resp = res.data
            if (resp.token) {
              Vue.cookie.set('user-token', resp.token, {expires: '1Y', domain: getters.hostname})
              Vue.cookie.set('user-name', resp.name, {expires: '1Y', domain: getters.hostname})
              commit('AUTH_SUCCESS', resp)
              commit('USER_SUCCESS', resp)
              resolve(resp)
            }
            if (resp.text) {
              alert(resp.text)
            }
          })
      })
    },
    AUTH_LOGOUT: ({ commit }) => {
      return new Promise(resolve => {
        commit('AUTH_LOGOUT')
        Vue.cookie.delete('user-token')
        resolve()
      })
    },
    USER_REQUEST: ({ commit, dispatch, getters }) => {
      commit('USER_REQUEST')
      axios({ url: 'backend/profile' })
        .then(resp => {
          Vue.cookie.set('user-name', resp.data.subdomain, {expires: '1Y', domain: getters.hostname})
          commit('USER_SUCCESS', resp.data)
        })
        .catch(() => {
          // if resp is unauthorized, logout, to
          // dispatch('AUTH_LOGOUT')
        })
      var token = Vue.cookie.get('user-token').split(';')
      var user = {
        username: token[3],
        password: token[4]
      }
      axios({ url: 'api/auth', data: user, method: 'POST' })
        .then(res => {
          var resp = res.data
          if (resp.token) {
            Vue.cookie.set('user-token', resp.token, {expires: '1Y', domain: getters.hostname})
            Vue.cookie.set('user-name', resp.name, {expires: '1Y', domain: getters.hostname})
            commit('AUTH_SUCCESS', resp)
            commit('USER_SUCCESS', resp)
          }
          if (resp.text) {
            commit('USER_ERROR')
            dispatch('AUTH_LOGOUT')
          }
        })
    }
  },
  mutations: {
    AUTH_REQUEST: state => {
      state.status = 'loading'
    },
    AUTH_SUCCESS: (state, resp) => {
      state.status = 'success'
      state.token = resp.token
      state.hasLoadedOnce = true
    },
    AUTH_ERROR: state => {
      state.status = 'error'
      state.hasLoadedOnce = true
    },
    AUTH_LOGOUT: state => {
      state.token = ''
      state.profile = {}
    },
    USER_REQUEST: state => {
      state.status = 'loading'
    },
    USER_SUCCESS: (state, resp) => {
      state.status = 'success'
      Vue.set(state, 'profile', resp)
    },
    USER_ERROR: state => {
      state.status = 'error'
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js